import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default (message, position = toast.POSITION.BOTTOM_RIGHT) => {
  toast.success(message || 'success', {
    position: position,
  });
};
